import { GetServerSideProps } from "next";
import Head from "next/head";
import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import CheckoutForm from "../../../../components/checkout/CheckoutForm";
import config from "../../../../config";
import { ClientConfiguration } from "../../../../models/ClientConfiguration";
import { EcommerceEventList } from "../../../../models/Event";
import { useCartStore } from "../../../../stores/CartStore";
import { setupStyleMapFromStyleMap } from "../../../../utils/helpers";
import { COOKIE_BOXOFFICE_KEY } from "../../../../stores/AuthStore";
import { tokenIsValid } from "../../../../utils/jwtHelpers";

export default function Home(props: {
    eventList: EcommerceEventList;
    clientConfig: ClientConfiguration | null;
}) {
    useCartStore(props.eventList.cartUrl);

    const pageTitle = `${props.eventList.clientName} Checkout | AuthentiGATE`;

    return (
        <>
            <Head>
                <title>{pageTitle}</title>
                <meta
                    name="description"
                    content={`${props.eventList.clientName} ticket checkout.`}
                />
                <meta name="robots" content="noindex" />
            </Head>
            <GoogleReCaptchaProvider reCaptchaKey="6Lc1XW4kAAAAACMuJ96qI9fgbsm03ItN2ah-fIny">
                <CheckoutForm {...props} />
            </GoogleReCaptchaProvider>
        </>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    const cartUrl = context.params?.cartUrl;
    let data: any,
        clientConfig: any = null,
        error = false;

    const boxoffice = context.req.cookies[COOKIE_BOXOFFICE_KEY];
    let salesContext = "ECOMMERCE";

    if (
        boxoffice == "true" &&
        tokenIsValid(
            context.req.cookies[
                config.COOKIE_PREFIX + "__authentigate_token_sanitized"
            ],
        )
    ) {
        salesContext = "BOXOFFICE";
    }

    try {
        const res = await fetch(
            `${config.BACKEND_URI}/sales/cart-style/${cartUrl}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "X-Sales-Context": salesContext,
                    Cookie: context.req.headers.cookie ?? "",
                },
                credentials: "include",
            },
        );
        if (res.status !== 200) {
            error = true;
            console.log(await res.text());
        } else {
            data = await res.json();
        }
    } catch (err) {
        console.log(err);
        error = true;
    }

    if (salesContext === "ECOMMERCE") {
        try {
            const res = await fetch(
                `${config.BACKEND_URI}/sales/client-configuration/${cartUrl}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Sales-Context": "ECOMMERCE",
                    },
                },
            );
            if (res.status !== 200) {
                error = true;
                console.log(await res.text());
            } else {
                clientConfig = await res.json();
            }
        } catch (err) {
            console.log(err);
            error = true;
        }
    }

    if (data?.newStyleMap) {
        setupStyleMapFromStyleMap(data.newStyleMap);
    }

    return {
        props: { eventList: data, clientConfig },
        notFound: error,
    };
};
